module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("12")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Die Zeit")]), _vm._v(", die meine\nReise braucht,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nist lang, und der Weg ist lang.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich kam heraus auf dem Wagen im"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nersten Strahle des Lichts und setzte die"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nFahrt weiter fort durch die Wildnis der"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nWelten und ließ meine Spur auf manchem"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nStern und Planeten.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Es ist der fernste Weg, der am nächsten"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nführt zu dir selbst, und jene Übung"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nist die schwierigste, die zum allereinfachsten"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nTon kommt.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("An jede fernste Türe muß der Wanderer"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nklopfen, bis er zur eigenen gelangt,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndurch alle äußeren Welten muß man ziehn,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzuletzt zum Allerheiligsten zu kommen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und meine Augen streiften weit und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nbreit, eh ich sie schloß und sprach: »Hier"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nbist du!« "), _c('a', {
    attrs: {
      "id": "page16",
      "title": "mabarosa/wedi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Frage und der Ruf: »O wo?« zerschmilzt"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nin tausend Tränenströmen und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nertränkt die Welt mit der Flut der Versichrung"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n»Ich bin«! "), _c('a', {
    attrs: {
      "id": "page17",
      "title": "mabarosa/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b1f9d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0013.vue
// module id = 93
// module chunks = 0